"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddToCartCommand = void 0;
const generate_content_1 = require("../utils/generate-content");
class AddToCartCommand {
    constructor(input) {
        this.input = input;
    }
    execute(config) {
        const { contents, customer, eventType, value, total_quantity } = this.input;
        const { cdp: cdpTracking } = config;
        const hashCustomerId = cdpTracking?.helper.md5(customer?.id ?? '');
        cdpTracking?.web_event.track('product', 'add_to_cart', {
            items: contents?.map((content) => ({
                ...(0, generate_content_1.generateContentItem)(content),
                cdp_source: 'Production',
                quantity: content.quantity,
            })) ?? [],
            ...(customer && {
                dims: {
                    customers: {
                        customer_id: customer?.id ? hashCustomerId : 'no-customer-id',
                        name: customer?.name ?? 'no-customer-name',
                        email: customer?.email?.toLowerCase() ?? 'no-customer-email',
                        phone: customer?.phone ?? 'no-customer-phone',
                        cdp_source: 'Production',
                    },
                },
            }),
            extra: {
                event_source: eventType ?? 'add_to_cart',
                cart_subtotal: value,
                cart_item_count: total_quantity,
            },
        });
        return Promise.resolve();
    }
}
exports.AddToCartCommand = AddToCartCommand;
